import axiosInstance from '../../../axiosInstance';
import apiEndpoints from '../../../api';

// ---------- Society Roles (A1–A6) ----------

export const getSocietyRolesReq = (action) => {
  const societyId = action?.data?.society_id;
  const url = apiEndpoints.GET_SOCIETY_ROLES_API.replace(':societyId', societyId);
  return axiosInstance.get(url);
};

export const getSocietyRoleDetailsReq = (action) => {
  const societyId = action?.data?.society_id;
  const roleId = action?.data?.role_id;
  const url = apiEndpoints.GET_SOCIETY_ROLE_DETAILS_API
    .replace(':societyId', societyId)
    .replace(':roleId', roleId);
  return axiosInstance.get(url);
};

export const createSocietyRoleReq = (action) => {
  const societyId = action?.data?.society_id;
  const url = apiEndpoints.CREATE_SOCIETY_ROLE_API.replace(':societyId', societyId);
  const payload = {
    role_name: action?.data?.role_name,
    role_code: action?.data?.role_code,
    description: action?.data?.description ?? null,
  };
  return axiosInstance.post(url, payload);
};

export const updateSocietyRoleReq = (action) => {
  const societyId = action?.data?.society_id;
  const roleId = action?.data?.role_id;
  const url = apiEndpoints.UPDATE_SOCIETY_ROLE_API
    .replace(':societyId', societyId)
    .replace(':roleId', roleId);
  const payload = {};
  if (action?.data?.role_name !== undefined) payload.role_name = action.data.role_name;
  if (action?.data?.role_code !== undefined) payload.role_code = action.data.role_code;
  if (action?.data?.description !== undefined) payload.description = action.data.description;
  if (action?.data?.is_active !== undefined) payload.is_active = action.data.is_active;
  return axiosInstance.put(url, payload);
};

export const deleteSocietyRoleReq = (action) => {
  const societyId = action?.data?.society_id;
  const roleId = action?.data?.role_id;
  const url = apiEndpoints.DELETE_SOCIETY_ROLE_API
    .replace(':societyId', societyId)
    .replace(':roleId', roleId);
  return axiosInstance.delete(url);
};

export const assignRolePermissionsReq = (action) => {
  const societyId = action?.data?.society_id;
  const roleId = action?.data?.role_id;
  const url = apiEndpoints.ASSIGN_ROLE_PERMISSIONS_API
    .replace(':societyId', societyId)
    .replace(':roleId', roleId);
  const payload = { permission_ids: action?.data?.permission_ids || [] };
  return axiosInstance.put(url, payload);
};

export const getPermissionCatalogReq = (action) => {
  const societyId = action?.data?.society_id;
  const url = apiEndpoints.GET_PERMISSION_CATALOG_API.replace(':societyId', societyId);
  const params = {};
  if (action?.data?.page) params.page = action.data.page;
  if (action?.data?.limit) params.limit = action.data.limit;
  if (action?.data?.module) params.module = action.data.module;
  if (action?.data?.resource) params.resource = action.data.resource;
  if (action?.data?.is_active !== undefined) params.is_active = action.data.is_active;
  return axiosInstance.get(url, { params });
};

export const getPermissionCatalogGroupedReq = (action) => {
  const societyId = action?.data?.society_id;
  const url = apiEndpoints.GET_PERMISSION_CATALOG_GROUPED_API.replace(':societyId', societyId);
  return axiosInstance.get(url);
};

// ---------- User ↔ Society (C1–C6) ----------

export const getMySocietiesReq = () => {
  return axiosInstance.get(apiEndpoints.GET_MY_SOCIETIES_API);
};

export const getMyPermissionsReq = (action) => {
  const societyId = action?.data?.society_id;
  return axiosInstance.get(apiEndpoints.GET_MY_PERMISSIONS_API, {
    params: societyId ? { society_id: societyId } : {},
  });
};

export const getSocietyUsersReq = (action) => {
  const societyId = action?.data?.society_id;
  const url = apiEndpoints.GET_SOCIETY_USERS_API.replace(':societyId', societyId);
  const params = {
    page: action?.data?.page || 1,
    limit: action?.data?.limit || 10,
  };
  return axiosInstance.get(url, { params });
};

export const createUserSocietyReq = (action) => {
  const payload = {
    user_id: action?.data?.user_id,
    society_id: action?.data?.society_id,
    role_id: action?.data?.role_id,
    is_primary: action?.data?.is_primary ?? 0,
  };
  return axiosInstance.post(apiEndpoints.CREATE_USER_SOCIETY_API, payload);
};

export const updateUserSocietyReq = (action) => {
  const id = action?.data?.id;
  const url = apiEndpoints.UPDATE_USER_SOCIETY_API.replace(':id', id);
  const payload = {};
  if (action?.data?.role_id !== undefined) payload.role_id = action.data.role_id;
  if (action?.data?.is_primary !== undefined) payload.is_primary = action.data.is_primary;
  if (action?.data?.is_active !== undefined) payload.is_active = action.data.is_active;
  return axiosInstance.put(url, payload);
};

export const deleteUserSocietyReq = (action) => {
  const id = action?.data?.id;
  const url = apiEndpoints.DELETE_USER_SOCIETY_API.replace(':id', id);
  return axiosInstance.delete(url);
};
